import React, { useState, useEffect } from 'react'
import { Field } from 'formik'
import { LinearProgress, TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText, Button } from '@material-ui/core'
// import axios from 'axios'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector } from 'react-redux'
import { myBucket } from '../services/UploadService'
import axios from 'axios'
import { ApiURL } from '../constants/ApiUrl'

function FormPage2E({ errors, touched, setFieldValue, values, appId }) {
    const qual = useSelector(state => state.FormDataReducer.qual)
    const [DocStatus, setDocStatus] = useState('');
    const [QualState, setQualState] = useState('')
    const [Progress3, setProgress3] = useState(0)
    const [stateList, setStateList] = useState([]);   // 25 oct  jyoti
    const [collegeList, setCollegeList] = useState([])        // 25 oct jyoti added for NMO state list and prant list from database
    const [SName, setSName] = useState('');
    const [CName, setCName] = useState('');
    const [isTrue, setIsTrue] = useState(true)

    useEffect(() => {
        a();
        if (values.state != "") {
            stateChanged(values.state)
        }
    }, [])
    var s = []
    const a = async () => {
        const result = await axios.get(`${ApiURL}/api/get_states`);
        result.data.forEach(element => {
            s.push(element.state_name)
        });
        setStateList(s)
    }
    const stateChanged = async (e) => {
        setSName(values.state);
        setFieldValue("state", e);
        const result = await axios.post(`${ApiURL}/api/get_medical_college`, {
            "state": e
            
        });
        console.log(result, 'medical collages')
        var college=[]
        const college_list = result.data
        college_list.forEach(element => {
            college.push(element)
        });
        setCollegeList(college)
    }
    const collegeChanged = (e) => {
        if (e.target.value === "other") {
            setIsTrue(false)
        }
        setFieldValue("college1", e.target.value);
    }
    useEffect(() => {
        setSName(values.state);
        setCName(values.college1);
    }, [values.state, values.college1])
    useEffect(() => {
        setDocStatus(values.docstatus1)
        console.log(DocStatus, "docccc")
        setQualState(values.qualifications1);
    }, [values.docstatus1, values.qualifications1])

    const handleQual = (e, val) => {
        e.preventDefault();
        setFieldValue("qualifications1", val);
        setQualState(val);
    }
    const handleCC = (e, val) => {
        setQualState(val);
    }

    const handleASClose = (e, val) => {
        if (val !== 'select-option') {
            setFieldValue("qualifications1", QualState);
        }
    }

    const statusChange = (e) => {
        e.preventDefault();
        console.log(e.target.value, "gfjhg");
        setFieldValue("docstatus1", e.target.value);
        setDocStatus(e.target.value)
    }
const uploadDoc = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png", "pdf"].includes(ext)) {
      alert("Only JPG, BMP, PNG & PDF files allowed");
      return;
    }

    const params = {
      Key: `applications/${appId}/cert_image1.${ext}`,
      ContentType: file.type,
    };

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      ApiURL +
        `/api/upload/signed-url?key=${encodeURIComponent(params.Key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload with progress (XHR)
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress3(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error("Upload failed due to network error"));

      xhr.send(file);
    });

    // 3️⃣ Update form field with R2 public URL
    setFieldValue(
      "cert_image1",
      `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${params.Key}`
    );
    console.log("File uploaded successfully: ", params.Key);
  } catch (e) {
    console.error("Upload error (doc):", e);
  }
};


    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="norFlexCon">
                <div className="ctrl">
                    <FormControl variant="outlined" fullWidth >
                        <InputLabel id="docStatusLabel">Applicant is a Student or Doctor*</InputLabel>
                        <Field name="docstatus1" labelId="docStatusLabel" value={DocStatus} label="Are You Student or Doctor*" as={Select} fullWidth onChange={statusChange}>
                            <MenuItem value=''>Select Status</MenuItem>
                            <MenuItem value='doctor'>Doctor</MenuItem>
                            <MenuItem value='student'>Student</MenuItem>
                        </Field>
                        <FormHelperText error>{touched.docstatus1 && errors.docstatus1}</FormHelperText>
                        <FormHelperText>* Register yourself as a doctor if you have a valid MCI License.</FormHelperText>
                    </FormControl>
                </div>
                {
                    DocStatus !== '' &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div className="ctrl">
                            <FormControl fullWidth error={touched.qualifications1 && errors.qualifications1}>
                                <Autocomplete freeSolo={true} options={qual} value={values.qualifications1} onChange={handleQual} onInputChange={handleCC} onClose={handleASClose}
                                    renderInput={(params) => <TextField {...params} label="Highest Medical Degree*" variant="outlined" />}
                                />
                                <FormHelperText error>{touched.qualifications1 && errors.qualifications1}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className="ctrl">
                            <FormControl variant="outlined" fullWidth error={touched.state && errors.state}>
                                <InputLabel id="stateLabel">State *</InputLabel>
                                <Field name="state" label="State *" labelId="stateLabel" as={Select} value={SName} variant="outlined" onChange={(e)=>stateChanged(e.target.value)} fullWidth error={touched.state && errors.state} helperText={touched.state && errors.state} >
                                    <MenuItem value=''>Select State</MenuItem>
                                    {
                                        stateList.map((item, index) => {

                                            return <MenuItem key={index} value={item}>{item}</MenuItem>

                                        })
                                    }
                                </Field>
                                <FormHelperText error>{touched.state && errors.state}</FormHelperText>
                            </FormControl>
                        </div>
                        {isTrue ? <div className="ctrl">
                            <FormControl variant="outlined" fullWidth error={touched.college1 && errors.college1}>
                                <InputLabel id="collegeLabel">College *</InputLabel>
                                <Field name="college1" label="College *" as={Select} variant="outlined" fullWidth value={CName} onChange={collegeChanged} error={touched.college1 && errors.college1} helperText={touched.college1 && errors.college1}>
                                    <MenuItem value=''>Select College</MenuItem>
                                    {
                                        collegeList.map((item, index) => {


                                            return <MenuItem key={index} value={item}>{item}</MenuItem>

                                        })
                                    }
                                </Field>
                                <FormHelperText error >{touched.college1 && errors.college1}</FormHelperText>
                            </FormControl>
                        </div> : <div className="ctrl">
                            <Field name="college1" label={"UG College *"} as={TextField} variant="outlined" fullWidth error={touched.college1 && errors.college1} helperText={touched.college1 && errors.college1} />
                        </div>}
                        <div className="ctrl">
                            <Field name="regno1" label={DocStatus === 'doctor' ? "Medical or Dental Council License Number" : "College Registration Number"} as={TextField} variant="outlined" fullWidth error={touched.regno1 && errors.regno1} helperText={touched.regno1 && errors.regno1} />
                        </div>
                        <div className="ctrl">
                            <Button variant="contained" component="label" fullWidth>
                                {DocStatus === 'doctor' ? "Medical or Dental Council License Upload" : "College ID Upload"}
                                <input name="cert_image1" type="file" hidden onChange={uploadDoc} />
                                <FormHelperText error>{touched.cert_image1 && errors.cert_image1}</FormHelperText>
                            </Button>
                            {values.cert_image1 !== '' && <a href={values.cert_image1} target="_blank" rel="noreferrer">View Uploaded Document</a>}
                            <LinearProgress variant="determinate" value={Progress3} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default FormPage2E
